import React from 'react';
import { Routes, Route } from 'react-router-dom';
import "./App.css";
import "./styles/ServiceRichText.css";
import "./styles/IndustryUseCases.css";
import "./styles/ServiceFAQ.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SecurityPage from "./components/SecurityPage";
import WhyUsPage from "./components/WhyUsPage";
import AboutUsPage from "./components/AboutUsPage";
import ServicesPage from "./components/ServicesPage";
import EnhancedServiceDetailPage from "./components/EnhancedServiceDetailPage";
import ContactPage from "./components/ContactPage";
import IndustriesPage from "./components/IndustriesPage";
import HomePage from "./components/HomePage";
import IndustryDetailPage from './components/industries/IndustryDetailPage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';

function App() {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col overflow-x-hidden">
      <div className="mx-auto w-full flex-grow flex flex-col">
        <Navbar />
        <div>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/security" element={<SecurityPage />} />
            <Route path="/why-us" element={<WhyUsPage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:serviceId" element={<EnhancedServiceDetailPage />} />
            <Route path="/industries" element={<IndustriesPage />} />
            
            {/* Generic industry detail route for all industries */}
            <Route path="/industries/:industryId" element={<IndustryDetailPage />} />
            
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          </Routes>
        </div>
        <div className="footer-wrapper">
        <Footer />
      </div>
      </div>
    </div>
  );
}

export default App;